<template>
    <div>
        <img class="img" v-if="templateArgs.data.icone" :src="templateArgs.data.icone || imgDefault" />
    </div>
</template>

<script>
export default {
    name: 'templateCapa',
    data: () => ({
        templateArgs: {}
    }),
    computed: {
        imgDefault() {
            return null
        }
    },
}
</script>

<style lang="scss" scoped>
.img {
    width: 35px;
    height: 35px;
    object-fit: cover;
}
</style>